import React, { useState } from "react";
import { httpReauest } from "../../../utils/httpRequest";
import { toast } from "react-toastify";

const TwitterModal = ({ setShow, getData }) => {
  const [text, setText] = useState();
  const [loading, setLoading] = useState();

  console.log(setShow);

  async function handleSubmit(e) {
    e.preventDefault();
    const user = JSON.parse(localStorage.getItem("user"));
    setLoading(true);
    await httpReauest(
      "POST",
      "/user/twitter",
      { url: text },
      { "x-access-token": user?.token }
    )
      .then((res) => {
        toast.success("Successfull");
        getData();
        setShow(false);
      })
      .catch((data) => {
        setLoading(false);
        toast.error(data?.response?.data?.message);
      });
  }
  return (
    <div className="fixed p-5 bg-[#02006A] z-50 left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2 w-[340px] rounded-[14px]">
      <h4 className="text-[20px] text-white font-bold text-center">
        Insert Post Url
      </h4>
      <p className="mt-1 text-center text-white/90">
        share a post on twitter and it should mentioned "filetrust"
      </p>
      <form
        onSubmit={handleSubmit}
        className="flex flex-col justify-center gap-2 items-center mt-4"
      >
        <input
          onChange={(e) => setText(e.target.value)}
          className="w-full form-brand text-black"
          placeholder="Twitter post url"
        />
        <button disabled={loading} type="submit" className="btn-brand">
          {loading ? "Loading..." : "Submit"}
        </button>
      </form>
    </div>
  );
};

export default TwitterModal;
